import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import SingleProductAddToCart from './components/single-product-add-to-cart';
import ScrollEventTracker from './components/scroll-event-tracker';
$(() => {
    ModalVideoWithParameters.init();
    RevealWhenVisible.init();
    InlineVideo.init();
    ResponsiveVideo.init();
    SingleProductAddToCart.init();
    ScrollEventTracker.init();
});
